import {useEffect, useRef} from "react";
import styled from "styled-components";
import Textarea from 'react-textarea-autosize';
import Button from "./button";
import {themecolors} from "../utils/themecolors";

const Edit = styled(Textarea)`
  border: 1px solid #777;
`;

const MarkdownField = styled((
    {
        className, id, placeholder,
        value, onChange,
        minRows=7,
        maxRows=15,
        autofocus=false,
    }
) => {
    const textareaRef = useRef(null);
    useEffect(() => {
        if (autofocus) {
            textareaRef.current?.focus();
        }
    }, [autofocus]);

    const handleChange = (event) => {
        onChange(event.currentTarget.value);
    };
    return (
        <div className={className}>
            <Edit
                    id={id} value={value} onChange={handleChange}
                    minRows={minRows} maxRows={maxRows}
                    placeholder={placeholder}
                    maxLength={15000}
                    ref={textareaRef}
                    autofocus
                  />
        </div>
    )
})`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
  textarea::placeholder {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_low_impact_text : themecolors.light_low_impact_text};
  }
  textarea {
    padding: 8px 24px;
    border: ${({theme}) => theme.form.inputBorder} solid #f2f2f2;
    border-radius: 6px;
    width: 100%;
    font-size: 16px;
    font-family: inherit;
    ${({theme}) => `
        color: ${theme.control.color};
        background-color: ${theme.color.name === 'dark' ? themecolors.dark_background_1 : theme.white_0};
    `}
  }
  ${Button} {
    background-color: transparent;
  }
`;

export default MarkdownField;
